module.exports = __webpack_public_path__ + "static/logo-main-black-9c5d10438404ebb1a1bf70b8c6dca12d.png";